// React
import React, { ReactElement } from 'react';
// Next
import { useTranslation } from 'next-i18next';
// Context
import { useDashboard } from '@utmb/contexts/DashboardContext';
// Types
import { RunnerCardsProps } from '@utmb/types/runner-cards';
// Styles
import styles from './registrations.module.scss';
import { RegistrationStatusEnum } from '@utmb/types/enum/RegistrationStatusEnum';
import { RegistrationCardRemake } from '../my-utmb/registration-card-remake/RegistrationCardRemake';
import { Placeholder } from '../my-utmb/placeholder/placeholder';
const RegistrationsList = (props: RunnerCardsProps): ReactElement => {
    const { limit } = props;
    const { t } = useTranslation('myutmb');
    const { dashboardMember } = useDashboard();

    if (!dashboardMember?.worldSeriesRegistrations?.length) {
        return (
            <div className={[styles.registration_list, styles.empty].join(' ')}>
                <Placeholder
                    cta={{ label: t('myUtmb.registration.banner.link'), action: '/utmb-world-series-events' }}
                    image="/worldseries/MYUTMB+/placeholder-2.jpg"
                    variant="big"
                />
            </div>
        );
    }

    let registrations = limit
        ? dashboardMember.worldSeriesRegistrations
              .filter((reg) => reg.status !== RegistrationStatusEnum.CANCELLED && reg.status !== RegistrationStatusEnum.PREREGISTERED_CANCELLED)
              .slice(0, limit)
        : dashboardMember.worldSeriesRegistrations;

    if (registrations.length === 0) registrations = limit ? dashboardMember.worldSeriesRegistrations.slice(0, limit) : dashboardMember.worldSeriesRegistrations;

    return (
        <div className={styles.registrationList}>
            {registrations.map((item, i) => (
                <RegistrationCardRemake key={i} data={item} />
            ))}
        </div>
    );
};

export default RegistrationsList;
